import type { Connect4View } from '@minigame-race/contracts';
import type { MinigameProps } from '../../race/types.js';
import { ConnectFourBoard } from '../../turn/ConnectFourBoard.js';
import { TurnBoardFrame } from '../../turn/TurnBoardFrame.js';

/**
 * Connect Four as a race segment. The shared board + turn metadata arrive on the
 * per-seat `view` (the server's turn adapter attaches yourSeat/yourTurn); moves
 * ride the generic `emit` channel like any other minigame.
 */
export function ConnectFourGame({ view, emit }: MinigameProps) {
  const v = view as Connect4View | null;
  if (!v) return null;
  return (
    <TurnBoardFrame>
      <ConnectFourBoard view={v} yourSeat={v.yourSeat} yourTurn={v.yourTurn} onMove={emit} />
    </TurnBoardFrame>
  );
}
